import { render, staticRenderFns } from "./TableDfe.vue?vue&type=template&id=5d7a1876&scoped=true&"
import script from "./TableDfe.vue?vue&type=script&lang=js&"
export * from "./TableDfe.vue?vue&type=script&lang=js&"
import style0 from "./TableDfe.vue?vue&type=style&index=0&id=5d7a1876&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7a1876",
  null
  
)

export default component.exports